import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { D as DropdownItemDisplayName } from '../displayNames-CI4WGOeZ.js';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { S as SelectOption } from '../../SelectList/SelectOption/SelectOption-Cf_51B9V.js';

const DropdownItemOption = withTaktFallbackId(SelectOption);
const DropdownItem = ({
  disabled = false,
  value,
  renderStart,
  renderEnd,
  renderAfter,
  children,
  hidden = false,
  ...rest
}) => {
  const taktFallbackId = createStormTaktId('dropdown-item');
  return /*#__PURE__*/React__default.createElement(DropdownItemOption, _extends({
    taktFallbackId: taktFallbackId
  }, rest, {
    hidden: hidden,
    value: value,
    renderStart: renderStart,
    renderEnd: renderEnd,
    renderAfter: renderAfter,
    disabled: disabled
  }), children);
};
DropdownItem.displayName = DropdownItemDisplayName;

export { DropdownItem as D };
//# sourceMappingURL=DropdownItem-BzQRvaXb.js.map
